import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../store";
import { getTables } from "../../slices/Tables/thunk";
import { getZones } from "../../slices/Zones/thunk";
import { createTableQr } from "../../slices/TableQrs/thunk";
import { showAlertWithTimeout } from "../../slices/Alert/reducer";
import { resolveApiMessage } from "../../helpers/apiMessage";
import HeaderSidebarToggle from "../../Components/Common/HeaderSidebarToggle";

const QrCodeCreate = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { tables, loading, error } = useSelector((state: any) => state.Tables);
    const { zones } = useSelector((state: any) => state.Zones);
    const [selectedTableId, setSelectedTableId] = useState<string>("");

    useEffect(() => {
        dispatch(getTables(undefined));
        dispatch(getZones());
    }, [dispatch]);

    const options = useMemo(() => {
        const zoneMap = new Map((Array.isArray(zones) ? zones : []).map((z: any) => [String(z.id), z.name]));
        return (Array.isArray(tables) ? tables : []).map((t: any) => ({
            id: String(t.id),
            label: `${zoneMap.get(String(t.zone_id)) ?? t.zone?.name ?? "Chưa có khu vực"} - ${t.number ?? t.name}`,
        }));
    }, [tables, zones]);

    return (
        <React.Fragment>
            <div className="header-area" id="headerArea">
                <div className="container h-100 d-flex text-center align-items-center justify-content-between rtl-flex-d-row-r">
                    <div className="back-button me-2">
                        <Link to="/shop/qr">
                            <i className="mdi mdi-arrow-left"></i>
                        </Link>
                    </div>
                    <div className="page-heading"><h6 className="mb-0">Tạo mã QR</h6></div>
                    <HeaderSidebarToggle className="ms-2" />
                </div>
            </div>
            <div className="page-content-wrapper">
                <div className="container">
                    <div className="cart-wrapper-area py-3">
                        <div className="card"><div className="card-body">
                            <label className="form-label">Chọn bàn</label>
                            <select className="form-select" value={selectedTableId} onChange={(e) => setSelectedTableId(e.target.value)}>
                                <option value="">Chọn bàn</option>
                                {options.map((opt: any) => <option key={opt.id} value={opt.id}>{opt.label}</option>)}
                            </select>
                            {loading && <div className="form-text">Đang tải danh sách bàn...</div>}
                            {!loading && options.length === 0 && <div className="form-text text-danger">{error ?? "Chưa có bàn nào để tạo mã QR."}</div>}
                            <button
                                className="btn btn-primary mt-3"
                                disabled={!selectedTableId}
                                onClick={async () => {
                                    try {
                                        const response = await dispatch(createTableQr({ table_id: selectedTableId })).unwrap();
                                        dispatch(showAlertWithTimeout("success", "Thành công", resolveApiMessage(response, { status: 200 })));
                                    } catch (e: any) {
                                        const message = resolveApiMessage(e);
                                        dispatch(showAlertWithTimeout("danger", "Thất bại", message));
                                    } finally {
                                        setSelectedTableId("");
                                        navigate("/shop/qr");
                                    }
                                }}
                            >
                                Tạo QR
                            </button>
                        </div></div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default QrCodeCreate;
